import React from "react";

export type AuthStatusVariant = "warning" | "danger";

const variantStyles: Record<
  AuthStatusVariant,
  { iconBg: string; iconClass: string }
> = {
  warning: { iconBg: "bg-light-warning", iconClass: "text-warning" },
  danger: { iconBg: "bg-light-danger", iconClass: "text-danger" },
};

type AuthStatusCardProps = {
  title: string;
  description: string;
  icon: string;
  variant: AuthStatusVariant;
  actions?: React.ReactNode;
};

const AuthStatusCard = ({
  title,
  description,
  icon,
  variant,
  actions,
}: AuthStatusCardProps) => {
  const styles = variantStyles[variant];

  return (
    <div className="w-lg-550px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto text-center">
      <div
        className={`d-inline-flex align-items-center justify-content-center rounded-circle ${styles.iconBg} mb-6`}
        style={{ width: 72, height: 72 }}
      >
        <i
          className={`bi ${icon} ${styles.iconClass}`}
          style={{ fontSize: "2.25rem" }}
          aria-hidden
        />
      </div>
      <h1
        className="fw-bold fs-2 mb-3"
        style={{ color: "var(--bs-body-color) !important", opacity: 1 }}
      >
        {title}
      </h1>
      <p className="text-muted fs-6 mb-6 px-4">{description}</p>
      {actions}
    </div>
  );
};

export default AuthStatusCard;
